import * as React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import CardMembershipIcon from "@mui/icons-material/CardMembership";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import toast from "react-hot-toast";
import recomendarMembresia from "./recomendedPlan";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { questions } from "./questions";

export default function FormDialog({ open, setOpen, memberships = [] }) {
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [answers, setAnswers] = useState({});
  const navigate = useNavigate();

  const handleClose = () => {
    setOpen(false);
    setCurrentQuestion(0);
    setAnswers({});
  };

  const handleNext = () => {
    // Validar si la pregunta actual está respondida
    if (!answers[questions[currentQuestion].id]) {
      toast.error("Por favor responde esta pregunta antes de continuar");
      return;
    }

    if (currentQuestion < questions.length - 1) {
      setCurrentQuestion(currentQuestion + 1);
    }
  };

  const handlePrevious = () => {
    if (currentQuestion > 0) {
      setCurrentQuestion(currentQuestion - 1);
    }
  };

  const handleAnswerChange = (e) => {
    setAnswers({
      ...answers,
      [questions[currentQuestion].id]: e.target.value,
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    // Validar que todas las preguntas estén respondidas
    const allQuestionsAnswered = questions.every(
      (question) => answers[question.id]
    );

    if (!allQuestionsAnswered) {
      toast.error("Por favor responde todas las preguntas antes de enviar");
      return;
    }

    // console.log("Respuestas enviadas:", answers);
    // Si todas las respuestas son validas, enviar recomendacion
    if (!memberships && memberships.length === 0) {
      toast.error(
        "No se pudieron obtener las membresias. \n Intentelo más tarde"
      );
      return;
    }
    // console.log("Membresias a enviar", memberships);

    const recomendedPlan = recomendarMembresia(answers, memberships);
    // console.log("RecomendedPan:", recomendedPlan);
    if (recomendedPlan) {
      // console.log("Hay un plan recomendado", recomendedPlan);

      navigate("/memberships", {
        state: {
          membership: recomendedPlan,
        },
      });
    }

    handleClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Diseña el plan perfecto</DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent>
          <Box mb={3}>
            <Typography variant="h6" component="div" gutterBottom>
              {questions[currentQuestion].question}
            </Typography>
            {questions[currentQuestion].type === "select" ? (
              <FormControl fullWidth margin="normal">
                <InputLabel id={`${questions[currentQuestion].id}-label`}>
                  {questions[currentQuestion].label}
                </InputLabel>
                <Select
                  labelId={`${questions[currentQuestion].id}-label`}
                  id={questions[currentQuestion].id}
                  name={questions[currentQuestion].id}
                  value={answers[questions[currentQuestion].id] || ""}
                  label={questions[currentQuestion].label}
                  onChange={handleAnswerChange}
                  required
                >
                  {questions[currentQuestion].options.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            ) : (
              <TextField
                autoFocus
                required
                margin="normal"
                id={questions[currentQuestion].id}
                name={questions[currentQuestion].id}
                label={questions[currentQuestion].label}
                type={questions[currentQuestion].type}
                fullWidth
                variant="outlined"
                value={answers[questions[currentQuestion].id] || ""}
                onChange={handleAnswerChange}
              />
            )}
          </Box>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", gap: 2 }}>
          {currentQuestion > 0 && (
            <Button
              onClick={handlePrevious}
              variant="outlined"
              color="#e7ef7d"
              startIcon={<ArrowBackIosNewIcon />}
            >
              Anterior
            </Button>
          )}
          {currentQuestion < questions.length - 1 ? (
            <Button
              onClick={handleNext}
              variant="contained"
              sx={{ backgroundColor: "#e7ef7d" }}
              endIcon={<ArrowForwardIosIcon />}
            >
              Siguiente
            </Button>
          ) : (
            <Button
              type="submit"
              variant="contained"
              sx={{ backgroundColor: "#e7ef7d" }}
              startIcon={<CardMembershipIcon />}
            >
              Guardar
            </Button>
          )}
        </DialogActions>
      </form>
    </Dialog>
  );
}
